import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import spartaGlobalFunctions from '@sparta.global.utilities/sparta-global-functions-utility/dist/es5.js';

/**
 * Collection of CSS classes used across functions.
 * @constant {object}
 */
var SPINNERCLASS = {
  DISPLAY: {
    NONE: 'spa-spin--hidden'
  },
  VISIBILITY: {
    HIDDEN: 'spa-spin--invisible'
  }
};
var spartaSpinnerUtility = /*#__PURE__*/function () {
  function spartaSpinnerUtility() {
    _classCallCheck(this, spartaSpinnerUtility);
    this._delayTime = 10000;
    this._eventHandlersAttached = false;

    // Object for paramaterse to get pased into .show() function for spinner exentions.
    this.initOptions = {
      // If spinner is in view. If true, will change focus, scrolling user to spinner.
      focusOnLoad: false,
      // Force scrolling to spinner, even if not in viewport.
      // Works in conjunction with `focusOnLoad`.
      scrollIntoView: false
    };
  }
  return _createClass(spartaSpinnerUtility, [{
    key: "getTargetElements",
    value: function getTargetElements() {
      this._cancelDisabled = this._target.querySelector('.spa-spin-cancel-btn') && this._target.querySelector('.spa-spin-cancel-btn').classList.contains(SPINNERCLASS.DISPLAY.NONE);
      this._cancelBtn = this._target.querySelector('.spa-spin-cancel-btn');
      this._retryBtn = this._target.querySelector('.spa-spin-retry-btn');
      this._retryDisabled = this._retryBtn.classList.contains('spin-retry-disabled');
      this._loadMsg = this._target.querySelector('.spa-spin-load-msg');
      this._loadMsgInitialized = this._target.querySelector('.spa-spin-msg-init');
      this._loadInitMsg = this._loadMsgInitialized.getAttribute('data-init-msg');
      this._cancelMsg = this._target.querySelector('.spa-spin-cancel-msg');
      this._errorMsg = this._target.querySelector('.spa-spin-error-msg');
      this._loadText = this._target.querySelector('.spa-spin-msg-wrapper');
      this._hasSkin = this._target.querySelector('[data-spinner-skin]');
      this._skinBdrClass = 'spa-spinner--show-bdr';
      this._maxWidth = this._target.querySelector('[data-max-width]');
      if (this._maxWidth) {
        this._maxWidth.style.maxWidth = this._maxWidth.getAttribute('data-max-width');
      }
      if (this._retryBtn.getAttribute('data-override') === 'true') {
        this._retryBtn.innerHTML = this.spinnerGlobalParams.retryBtn;
      }
      if (this._cancelBtn.getAttribute('data-override') === 'true') {
        this._cancelBtn.innerHTML = this.spinnerGlobalParams.cancelBtn;
      }
    }

    /** optional - default 10 seconds
     * @param {number} delayTime - will display loading message after n milliseconds
     */
  }, {
    key: "delayTime",
    value: function delayTime(_delayTime) {
      if (_delayTime) {
        this._delayTime = _delayTime;
      }
      return this;
    }

    /** optional
     * @param onCancel - Callback function to be exectued if user clicks cancel
     */
  }, {
    key: "onCancel",
    value: function onCancel(_onCancel) {
      if (_onCancel) {
        this._onCancel = _onCancel;
      }
      return this;
    }

    /** optional
     * @param onRetry - Callback function to be exectued if user clicks retry
     */
  }, {
    key: "onRetry",
    value: function onRetry(_onRetry) {
      if (_onRetry) {
        this._onRetry = _onRetry;
      }
      return this;
    }

    /** required
     * @param {selector or Node} target - spinner target container
     */
  }, {
    key: "show",
    value: function show(target) {
      var setOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.initOptions;
      // merge settings
      var options = Object.assign({}, this.initOptions, setOptions);

      // Get global params
      var lang = spartaGlobalFunctions.getLanguage();
      var spaParam = spartaGlobalFunctions.getSpaParams();
      this.spinnerGlobalParams = spaParam.global[lang].spinner;

      // Element setup.
      this._target = target instanceof Element || _typeof(target) === 'object' ? target : document.querySelector(target);
      this.getTargetElements();
      this._loadText.classList.add(SPINNERCLASS.VISIBILITY.HIDDEN, SPINNERCLASS.DISPLAY.NONE);
      clearTimeout(this._messageTimeoutId);
      this.attachEventHandlers(options);
      this._target.querySelector('.spa-card').classList.remove(SPINNERCLASS.DISPLAY.NONE);
      this._loadMsgInitialized.innerHTML = this._loadInitMsg;
      this.startMsgTimer();

      // Sets focus to cancel button if allowed when spinner is init.
      if (this.setFocus(options, this._cancelBtn)) {
        this._cancelBtn.focus();
      }
      if (this._hasSkin && options.resetBorder) {
        this._hasSkin.classList.remove(this._skinBdrClass);
      }
      return this;
    }
  }, {
    key: "attachEventHandlers",
    value: function attachEventHandlers(options) {
      if (!this._eventHandlersAttached) {
        this._cancelBtn.addEventListener('click', this.cancel.bind(this, options), false);
        this._retryBtn.addEventListener('click', this.retry.bind(this, options), false);
        this._eventHandlersAttached = true;
      }
    }
  }, {
    key: "startMsgTimer",
    value: function startMsgTimer() {
      var _this = this;
      this._messageTimeoutId = setTimeout(function () {
        _this._loadMsgInitialized.classList.add(SPINNERCLASS.DISPLAY.NONE);
        _this._loadText.classList.remove(SPINNERCLASS.VISIBILITY.HIDDEN, SPINNERCLASS.DISPLAY.NONE);
      }, this._delayTime);
    }
  }, {
    key: "retry",
    value: function retry() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.initOptions;
      // hack to get screen reader to read the updated status
      this._cancelMsg.setAttribute('aria-hidden', 'true');
      this._errorMsg.setAttribute('aria-hidden', 'true');
      this._loadMsg.setAttribute('aria-hidden', 'false');
      if (!this._cancelDisabled) {
        this._cancelBtn.classList.remove(SPINNERCLASS.DISPLAY.NONE);
        if (this.setFocus(options, this._cancelBtn)) {
          this._cancelBtn.focus();
        }
      }
      this._retryBtn.classList.add(SPINNERCLASS.DISPLAY.NONE);
      this._cancelMsg.classList.add(SPINNERCLASS.DISPLAY.NONE);
      this._errorMsg.classList.add(SPINNERCLASS.DISPLAY.NONE);
      this._loadText.classList.add(SPINNERCLASS.DISPLAY.NONE);
      this._loadText.classList.add(SPINNERCLASS.VISIBILITY.HIDDEN);
      this._loadMsgInitialized.classList.remove(SPINNERCLASS.DISPLAY.NONE);
      this._loadMsg.classList.remove(SPINNERCLASS.DISPLAY.NONE);
      this.startMsgTimer();
      if (this._onRetry && !this._retryDisabled) {
        this.executeCallback(this._onRetry, 'onRetry');
      }
      if (this._hasSkin) {
        this._hasSkin.classList.remove(this._skinBdrClass);
      }
    }
  }, {
    key: "showError",
    value: function showError() {
      var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // Since object might be defined elsewhere, lets merge them.
      var options = Object.assign(this.initOptions, settings);
      this._loadMsg.setAttribute('aria-hidden', 'true');
      this._cancelMsg.setAttribute('aria-hidden', 'true');
      this._errorMsg.setAttribute('aria-hidden', 'false');
      this._loadMsgInitialized.classList.add(SPINNERCLASS.DISPLAY.NONE);
      this._cancelBtn.classList.add(SPINNERCLASS.DISPLAY.NONE);
      if (!this._retryDisabled) {
        this._retryBtn.classList.remove(SPINNERCLASS.DISPLAY.NONE);
        if (this.setFocus(options, this._retryBtn)) {
          this._retryBtn.focus();
        }
      }
      this._loadMsg.classList.add(SPINNERCLASS.DISPLAY.NONE);
      this._cancelMsg.classList.add(SPINNERCLASS.DISPLAY.NONE);
      this._errorMsg.classList.remove(SPINNERCLASS.DISPLAY.NONE);
      if (this._hasSkin) {
        this._hasSkin.classList.add(this._skinBdrClass);
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.initOptions;
      this._errorMsg.setAttribute('aria-hidden', 'true');
      this._loadMsg.setAttribute('aria-hidden', 'true');
      this._cancelMsg.setAttribute('aria-hidden', 'false');
      this._cancelBtn.classList.add(SPINNERCLASS.DISPLAY.NONE);
      this._loadMsgInitialized.classList.add(SPINNERCLASS.DISPLAY.NONE);
      if (!this._retryDisabled) {
        this._retryBtn.classList.remove(SPINNERCLASS.DISPLAY.NONE);
        if (this.setFocus(options, this._retryBtn)) {
          this._retryBtn.focus();
        }
      }
      this._loadMsg.classList.add(SPINNERCLASS.DISPLAY.NONE);
      if (!this._cancelDisabled) {
        this._cancelMsg.classList.remove(SPINNERCLASS.DISPLAY.NONE);
      }
      if (this._onCancel) {
        this.executeCallback(this._onCancel, 'onCancel');
      }
      if (this._hasSkin) {
        this._hasSkin.classList.add(this._skinBdrClass);
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this$_target;
      (_this$_target = this._target) === null || _this$_target === void 0 || _this$_target.querySelector('.spa-card').classList.add(SPINNERCLASS.DISPLAY.NONE);
    }
  }, {
    key: "executeCallback",
    value: function executeCallback(cb, name) {
      if (!cb) {
        return;
      }
      try {
        cb();
      } catch (err) {
        console.log("Error executing callback ".concat(name, ": ").concat(err));
      }
    }

    /**
     * Determines if spinner can set the focus on spinner DOM elements.
     * @param {Object} options - Object containing spinner instance default options.
     * @param {Object} element - DOM element to check viewport against.
     * Conditional logic checks for:
     *   1) force focus on load even if spinner is not in viewport.
     *   2) force focus on load if in viewport.
     *   3) User interacting with spinner, check if it's still in viewport.
     * @returns {void}
     */
  }, {
    key: "setFocus",
    value: function setFocus(options, element) {
      var setFocus = false;
      var inViewport = this.isElementInViewport(element);
      var setOnLoad = options.focusOnLoad || false;
      var scrollOnLoad = options.scrollIntoView || false;
      if (
      // Set focus on .show() and scroll into view
      setOnLoad && scrollOnLoad

      // Or set focus on load only if in viewport; but not on load.
      || setOnLoad && !scrollOnLoad && inViewport

      // Or set focus only if in viewport
      || inViewport) {
        setFocus = true;
      }
      return setFocus;
    }

    /**
     * Test if element is fully or partially in viewport
     * @param {Object} element - DOM element to test if in viewport.
     * @param {Boolean} partially - Boolean to see if partial or fully in view.
     * @returns {void}
     */
  }, {
    key: "isElementInViewport",
    value: function isElementInViewport(element) {
      var partially = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!element) {
        return false;
      }
      var rect = element.getBoundingClientRect();
      var windowHeight = window.innerHeight || document.documentElement.clientHeight;
      var windowWidth = window.innerWidth || document.documentElement.clientWidth;

      // Partially in view
      if (partially) {
        var vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
        var horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;
        return vertInView && horInView;
      }
      // Completely in view
      return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
    }
  }]);
}();
export { spartaSpinnerUtility as default };